import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledChartsPanel = styled(Box, {
  height: '100%',
  width: '100%',
});
